import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {
    RouterProvider,
} from "react-router-dom";
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import {ThemeProvider} from "@mui/material/styles";
import {theme} from "./app/theme";
import {AuthManager} from "./features/auth/context/AuthManager";
import {AuthManagerDev} from "./features/auth/context/AuthManagerDev";
import {SnackbarProvider} from "./common/context/SnackbarContext";
import router from "./app/routes";
import {DeckProvider} from "./features/deck-management/context/DeckContext";
import {AudioProvider} from "./common/context/AudioContext";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';


const root = ReactDOM.createRoot(document.getElementById('root')!);

const queryClient = new QueryClient();

if (process.env.REACT_APP_ENV === "development") {
    root.render(
        <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={theme}>
                <AuthManagerDev>
                    <SnackbarProvider>
                        <AudioProvider>
                            <DeckProvider>
                                <RouterProvider router={router}/>
                            </DeckProvider>
                        </AudioProvider>
                    </SnackbarProvider>
                </AuthManagerDev>
            </ThemeProvider>
        </QueryClientProvider>
    );
}

else {
    root.render(
        <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={theme}>
                <AuthManager>
                    <SnackbarProvider>
                        <AudioProvider>
                            <DeckProvider>
                                <RouterProvider router={router}/>
                            </DeckProvider>
                        </AudioProvider>
                    </SnackbarProvider>
                </AuthManager>
            </ThemeProvider>
        </QueryClientProvider>
    );
}
